import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import get from "lodash/get"
import { urls } from "utils-lib/builds"
import {
  GET_BULK_DISCLAIMER_SERVLET_FULFILLED,
  GET_BULK_DISCLAIMER_SERVLET_PENDING,
  GET_BULK_DISCLAIMER_SERVLET_FAILED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_BULK_DISCLAIMER_SERVLET_PENDING,
})

export const failedAC = (data) => ({
  type: GET_BULK_DISCLAIMER_SERVLET_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_BULK_DISCLAIMER_SERVLET_FULFILLED,
  payload: data,
})

export const getBulkDisclaimerServlet = () => (dispatch, getState) => {
  const { siteLanguage } = getState()
  const locale = encodeURI(siteLanguage?.language || ``)

  const api = `AEM_GET_BULK_DISCLAIMER`
  const template = URITemplate(urls.url[api])

  const exceptionURL = template.expand({
    locale: locale.replace("_", "-"),
  })
  const url = exceptionURL
  const config = {
    url,
    method: `get`,
  }

  dispatch(pendingAC(locale))
  // eslint-disable-next-line consistent-return
  return axios(config)
    .then((response) => {
      const data = get(
        response,
        `data.data.disclaimerWithCtaContentFragmentList.items[0]`,
        {},
      )
      dispatch(fulfilledAC(data))
      return response
    })
    .catch((error) => {
      dispatch(failedAC(error?.response?.status))
      return error
    })
}
